module.exports = __webpack_public_path__ + "img/196.0b9f28e0.png";